import { render, staticRenderFns } from "./ScheduledShippingServiceChargesComponent.vue?vue&type=template&id=5c7ca450&"
import script from "./ScheduledShippingServiceChargesComponent.vue?vue&type=script&lang=js&"
export * from "./ScheduledShippingServiceChargesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports